/**
 * Reads a quoted attribute out of a raw HTML tag, or undefined when the tag does not carry it.
 *
 * We never render author-supplied HTML, but we do recognise a few known shapes in GitHub PR
 * bodies (attachment images, the Cursor agent footer) and pull the pieces we need out of them.
 */
export function htmlAttr(tag: string, name: string): string | undefined {
  const match = new RegExp(name + '\\s*=\\s*(?:"([^"]*)"|\'([^\']*)\')', 'i').exec(tag);
  if (!match) return undefined;
  return match[1] !== undefined ? match[1] : match[2];
}
